import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
    maxSessionUntil: null,
  },
  reducers: {
    setCredentials: (state, action) => {
      const { token, maxSessionUntil } = action.payload;
      state.token = token;
      state.maxSessionUntil = maxSessionUntil || null;
    },
    clearCredentials: (state) => {
      state.token = null;
      state.maxSessionUntil = null;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;

export const selectCurrentToken = (state) => state.auth.token;
export const selectMaxSessionUntil = (state) => state.auth.maxSessionUntil;

export default authSlice.reducer;
